import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';

/**
 * Generated class for the OtherProductPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-other-product',
  templateUrl: 'other-product.html',
})
export class OtherProductPage {
  productContent: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private cp:CommonProvider,private loadingCtrl:LoadingController) {
  }

  ionViewDidLoad() {
   
	this.getAboutUsContent()
  }
  getAboutUsContent(){

  let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
  let data = this.cp.getOtherProductPage(loading) ;
	data.then((res:any)=>{
    loading.dismiss()
    var res=JSON.parse(res)
		 this.productContent = res.Payload.knowledgearticles[0].content;
     //console.log(this.productContent);
     
	}).catch(e=>loading.dismiss())
}

}



// WEBPACK FOOTER //
// ./src/pages/other-product/other-product.ts